import { useContext } from "react";
import NoteGridPanel from "../../../common/notes/components/NoteGridPanel";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function PurchaseOrderNotesPanel(props: { height?: string | number }) {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<NoteGridPanel
			notes={order.details.notes}
			height={props.height}
		/>
	)
}
